<script>
  export let className = '';
</script>

<header class="tools-hero-bg text-center py-14 {className} border-b border-slate-100 bg-white">
  <slot />
</header>
